import React, { useState, useEffect } from 'react';
import { useCSVReader, formatFileSize } from 'react-papaparse';
import { FiUploadCloud, FiTrash2 } from 'react-icons/fi'; // Icons for upload and remove


const parseData = (data) => {
  if (!data || data.length < 1) return null;
  const columns = data[0];
  const finalData = data.slice(1).map(row => {
    const obj = {};
    columns.forEach((col, index) => obj[col] = row[index]);
    return obj;
  });
  return finalData;
};

export default function CSVReader({ setCSVData, setFileName }) {
  const { CSVReader } = useCSVReader();
  const [zoneHover, setZoneHover] = useState(false);
  const [removeHoverColor, setRemoveHoverColor] = useState('#FF5C5C');
  const [currentFileName, setCurrentFileName] = useState(null);


  const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme")).theme.color_shades;


  useEffect(() => {
    if (currentFileName && setFileName) {
      setFileName(currentFileName);
    }
  }, [currentFileName, setFileName]);

  const styles = {
    zone: {
      alignItems: 'center',
      border: `2px dashed #D1D5DB`,  
      borderRadius: 8,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '120px',
      width: '100%',
      background: '#FAFAFA',
      transition: 'all 0.2s ease',
      cursor: 'pointer',
    },
    zoneHover: {
      borderColor: '#3B82F6',  // Blue on hover
      background: '#F8FAFC',
      borderStyle: 'solid',
    },
    fileContainer: {
      background: '#FFFFFF',
      borderRadius: 8,
      boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px',
      position: 'relative',
      width: '100%',
      maxWidth: '400px',
      margin: '0 auto',
    },
    fileInfo: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
      fontSize: '14px',
      color: '#374151',
    },
    progressBar: {
      marginTop: '8px',
      width: '100%',
    },
    remove: {
      position: 'absolute',
      top: '8px',
      right: '8px',
      cursor: 'pointer',
      padding: '4px',
      borderRadius: '4px',
      transition: 'background-color 0.2s ease',
    },
    icon: {
      fontSize: '40px',
      color: '#9CA3AF',
      marginBottom: '8px',
    },
    placeholderText: {
      fontSize: '16px',
      color: '#6B7280',
      marginTop: '8px',
      fontWeight: '500',
    },
  };
  return (
    <CSVReader
      onUploadAccepted={(results, file) => {
        const finalData = parseData(results.data);
        setCSVData({ ...results, headers: results.data[0], parsed: finalData, file });
        setCurrentFileName(file.name);
        setZoneHover(false);
      }}
      onDragOver={() => setZoneHover(true)}
      onDragLeave={() => setZoneHover(false)}
    >
      {({ getRootProps, acceptedFile, ProgressBar, getRemoveFileProps, Remove }) => (
        <div
          {...getRootProps()}
          style={{ ...styles.zone, ...(zoneHover && styles.zoneHover) }}
        >
          {acceptedFile ? (
            <div style={styles.fileContainer}>
              <div style={styles.fileInfo}>
                <span>{formatFileSize(acceptedFile.size)}</span>
                {/* <span>{acceptedFile.name}</span> */}
                <div style={styles.progressBar}><ProgressBar /></div>
              </div>
              <div
                {...getRemoveFileProps()}
                style={styles.remove}
                onMouseOver={() => setRemoveHoverColor('#FF8A8A')}
                onMouseOut={() => setRemoveHoverColor('#FF5C5C')}
              >
                <FiTrash2 size={18} color={removeHoverColor} />
              </div>
              <div>{acceptedFile.name}</div>
            </div>
          ) : (
            <>
              <FiUploadCloud style={styles.icon} />
              <div style={styles.placeholderText}>
                Drop CSV file here or click to upload
              </div>
              <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '4px' }}>
                Supports .csv files up to 10MB
              </div>
            </>
          )}
        </div>
      )}
    </CSVReader>
  );
}
